import { AccessToken } from "@/@types/auth";
import { Auth } from "@/models/auth";
import dayjs from "dayjs";
import { setLocalStorage } from "@/util/utils";
import { isValidUser, renewSessionService } from "./services/auth.service";

export async function isAccessTokenValid(): Promise<boolean> {
  if (!isAccessTokenNotExpired()) await renewSession();
  return isAccessTokenNotExpired() && (await isValidUser());
}

export function setTokens(accessToken?: string, refreshToken?: string) {
  setLocalStorage("session/tokens/accessToken", !accessToken ? undefined : accessToken);
  setLocalStorage("session/tokens/refreshToken", !refreshToken ? undefined : refreshToken);
}

export const getAccessToken = (): string => {
  return localStorage.getItem("session/tokens/accessToken") || "";
};

export const haveSession = (): boolean => {
  const token: string | null = getAccessToken();
  return token !== null && token.length > 0;
};

export async function renewSession(): Promise<boolean> {
  return await renewSessionService();
}

function isAccessTokenNotExpired() {
  const auth = new Auth();
  const accessToken: string = getAccessToken();

  if (!haveSession()) return false;
  try {
    auth.accessToken = auth.parseJwt(accessToken) as unknown as AccessToken;
    if (auth.accessToken.exp === undefined) return false;
    return auth.accessToken.exp > dayjs().unix();
  } catch {
    return false;
  }
}
